import _ from 'lodash';
import dayjs from 'dayjs';
import { Message } from 'element-ui';
import { searchFieldSeperated, validateSearchTime } from '@/modules/transport/otp/views/distributeManage/receiptCenter/search.js';

/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
export const formatSearchData = data => {
    const params = _.cloneDeep(data);
    const advanceList = ['carrierName', 'carrierCode', 'driver'];
    advanceStringToArray(params, advanceList);
    params.dispatchNoList = searchFieldSeperated(params.dispatchNo || '');
    params.tradeNoList = searchFieldSeperated(params.tradeNo || '');
    params.payDateStart = params.payDate ? dayjs(params.payDate[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.payDateEnd = params.payDate ? dayjs(params.payDate[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.payCreateStart = params.payCreateTime ? dayjs(params.payCreateTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.payCreateEnd = params.payCreateTime ? dayjs(params.payCreateTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    delete params.dispatchNo;
    delete params.tradeNo;
    delete params.payDate;
    delete params.payCreateTime;
    return params;
};

const advanceStringToArray = (data, advanceList) => {
    advanceList.forEach(key => {
        if (data[key]) {
            data[`${key}List`] = data[key] ? data[key].split(',') : [];
        }
        delete data[key];
    });
};

/**
 * @description 校验查询参数
 * @param {Object} data 查询参数
 */
export const validateSearchData = (data, maxNum = 100) => {
    const IsExitNumber = (data.dispatchNoList && data.dispatchNoList.length > 0) || (data.tradeNoList && data.tradeNoList.length > 0);
    const isExitTime = (data.payDateStart && data.payDateEnd) || (data.payCreateStart && data.payCreateEnd);
    if (!IsExitNumber && !isExitTime) {
        Message.warning('支付订单号、发车单号、支付日期、创建时间不可同时为空');
        return false;
    }
    const batchSearchField = ['dispatchNoList', 'tradeNoList'];
    if (maxLengthVerification(data, batchSearchField, maxNum)) {
        Message.warning(`按照单号查询，每次最多支持查询${maxNum}单`);
        return false;
    }
    return validateSearchTime(data, 'payDateStart', 'payDateEnd', 62) && validateSearchTime(data, 'payCreateStart', 'payCreateEnd', 62);
};

const maxLengthVerification = (data, fieldList, maxNum = 100) => {
    return fieldList.some(v => data[v] && data[v].length > maxNum);
};

export const formatTotalDataList = (data, dictData) => {
    if (!data.length) return [];
    data.forEach((item) => {
        item.hiddenEvent = [];
        // 当支付状态=支付中时，显示更新状态按钮
        if (+item.payStatus !== 1) {
            item.hiddenEvent.push('updateStatus');
        }
    });
    return data;
};